import React from 'react';

const Cta = ({ title, description, imageUrl, btnText, btnOnclick, bgClass, children }) => {

  return (
      <section className={ bgClass ? bgClass + " margin-auto": "shape-bg-warning shape-bg-warning-top margin-auto"}>
        <div className="container flex content-row image_left">
          <div className="col-12 col-lg-5 cta-image">
            <img decoding="async" src={imageUrl} alt="CTA" loading="lazy"></img>
          </div>
          <div className="col-12 col-lg-7 cta-content">
            <h2>{title}</h2>
            <p>{description}</p>
            <div className="button_container flex">
              <button className="btn secondary arrow" onClick={btnOnclick}>{btnText}</button>
            </div>
            {children}
          </div>
        </div>
      </section>
  );
};

export default Cta;
